import axios from "axios";
import BX24_api from "bx24-api";

/*export const BX24 = async (method, data, type = 'post') => {
    const webhook = 'https://m-k.bitrix24.ru/rest/136/k2rdmj4yms8r7por/'
    return axios({
        url: `${webhook}${method}`,
        method: type,
        data: data
    }).then(res => {
        return res.data
    })
}*/

export const BX24 = (method, data) => {
    return new Promise(resolve => {
        BX24_api.callMethod(method, data).then(res => {
            resolve(res?.answer)
        })
    })
}
